
    <div [ngClass]="label.color + ' ' +  className" class="label_tag_wrapper" title="{{shortView ? label.name : undefined}}">
      <div class="label_input">
        <p *ngIf="!shortView">
          {{label.name}}
        </p>
      </div>
      <div *ngIf="selected" class="check_controll">&#10003;</div>
    </div>
  